var _rect, _rect2, _path, _line, _line2, _line3, _line4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShower({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shower") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.44,
    y: 0.44,
    width: 15.02,
    height: 15.02,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.44.44",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.03,
    y1: 6.98,
    x2: 0.44,
    y2: 0.44,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.97,
    y1: 6.98,
    x2: 15.46,
    y2: 0.44,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.97,
    y1: 8.91,
    x2: 15.46,
    y2: 15.46,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.44,
    y1: 15.46,
    x2: 6.87,
    y2: 8.91,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.89,
    cy: 8.01,
    r: 1.45,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShower);
export default __webpack_public_path__ + "static/media/Shower.69fce45565363dabf5b90b7a2a1186eb.svg";
export { ForwardRef as ReactComponent };